import { FormEvent, MouseEvent, useEffect, useState } from "react";
import { exportFile } from "./utils/exportFile";
import Modal from 'react-modal';
import Stats from "../models/stats";
import styles from "../Charts/ExportModal";
// import { graphingMap } from "../Charts/chartService"
interface props {
    closeModal: () => void;
    data: Stats[],
    isOpen: boolean
}


function ExportModal({ closeModal, isOpen, data}: props) {
    const [filename,setFilename] = useState("hydromast-data-" + new Date().toISOString());
    const [filetype,setFiletype] = useState(".txt");

    useEffect(()=>{
        setFilename("hydromast-data-" + new Date().toISOString())
    },[isOpen])
    const exportModalStyles: Modal.Styles = {
        overlay: {
            zIndex: 1000
        },
        content: {
            position: 'absolute',
            top: '20%',
            left: '20%',
            right: '20%',
            bottom: '20%',
            border: '1px solid #E56791',
            background: '#EDECEC',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '10px',
            outline: 'none',
            padding: '20px',
            overflowX: 'hidden',
            overflowY: 'hidden',
        }
    }
    const labelStyle = {
        color: "white",
        fontFamily: "Arial",
        fontSize: "16px",
    };
    const listStyle = {
        fontFamily: "Arial",
        fontSize: "15px"
    }
    const btnStyle = {
        fontFamily: "Arial",
        fontSize: "18px"
    }
    const handleDataExport = (e: MouseEvent) => {
        e.preventDefault();
        if(filename==="" || !filetype){
            alert("Missing file name or type")
            return
        }
        if(!(filetype === ".txt" || filetype === ".json" || filetype === ".csv")){
            alert("Wrong file type!")
            return
        }
        exportFile(data,{
            filename:filename,
            filetype:filetype,
        })
    }
    
    return (
        <Modal
            bodyOpenClassName={'export-modal'}
            isOpen={isOpen}
            ariaHideApp={false}
            style={exportModalStyles}
            onRequestClose={() => closeModal()}
        >
            <div className="export-modal-content">
                <form>
                    <span style={{
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}>
                        <label style={labelStyle}>Export data options ...</label>
                        <button className="close-btn" onClick={() => closeModal()}></button>
                    </span>

                    <label htmlFor="filename" style={labelStyle}>Filename: </label>
                    <input style={{fontSize: "16px"}} name="filename" value={filename} onChange={(e)=>setFilename(e.target.value)}></input>

                    <label htmlFor="type" style={labelStyle}>File Type: </label>
                    <select style={listStyle} defaultValue={filetype} onChange={(e)=>setFiletype(e.target.value)}>
                        <option value=".txt">*.TXT</option>
                        <option value=".csv">*.CSV</option>
                        <option value=".json">*.JSON</option>
                    </select>
                    <button style={btnStyle} className="export-btn" onClick={(e) => handleDataExport(e)}>
                        &nbsp;Export ...&nbsp;
                    </button>
                </form>
            </div>
        </Modal>
    );
}

export default ExportModal;
